/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';

const FollowUpRuleIsComplete = BaseValidator.extend({
  intl: service(),

  validate(rules, options, model) {
    if (rules.isEvery('hasNonLogicalPredicates') && rules.isEvery('hasActions')) {
      return true;
    }

    if (options.message) {
      return this.intl.t(options.message);
    } else {
      return 'Your follow up rules are incomplete.';
    }
  },
});

FollowUpRuleIsComplete.reopenClass({
  getDependentsFor() {
    return [
      'model.followUpRules.@each.hasNonLogicalPredicates',
      'model.followUpRules.@each.hasActions',
    ];
  },
});

export default FollowUpRuleIsComplete;
